module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "audits"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "debounce",
      rawName: "v-debounce",
      value: (500),
      expression: "500"
    }],
    attrs: {
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 offset-md-1"
  }, [_c('b-button', {
    staticClass: "button-add",
    attrs: {
      "variant": "primary",
      "to": _vm.getAddAuditUrl()
    }
  }, [_vm._v("\n          Add audit\n        ")])], 1)]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": _vm.formData.audits.filter(_vm.isInFilter).length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table text-center table-hover border"
  }, [_c('thead', [_c('tr', _vm._l((_vm.formData.auditsFields), function(item) {
    return _c('th', {
      staticClass: "text-center align-middle"
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.formData.audits.filter(_vm.isInFilter)), function(item, index) {
    return ((_vm.currentPage - 1) * _vm.perPage <= index && index < (_vm.currentPage) * _vm.perPage) ? [
      [_c('tr', {
        on: {
          "click": function($event) {
            return _vm.onRowClick(item)
          }
        }
      }, [_c('td', {
        staticClass: "align-middle"
      }, [_vm._v("\n              " + _vm._s(+index + 1) + "\n            ")]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, [_c('b', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, [_c('div', {
        staticClass: "cell__text"
      }, [_c('b', [_vm._v(_vm._s(item.name))])])]), _vm._v(" "), _c('td', {
        staticClass: "text-left align-middle"
      }, _vm._l((_vm.getWorkingAreasListById(item.area, _vm.areas)), function(area) {
        return _c('div', [_vm._v("\n                " + _vm._s(area ? area.name : '')), (area.id != item.area) ? _c('span', [_vm._v("/")]) : _vm._e()])
      }), 0), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      })])]
    ] : _vm._e()
  })], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b23d112c","hasScoped":true}!./src/components/audits/audits.component.html
// module id = 552
// module chunks = 1